module.exports = __webpack_public_path__ + "img/zhuanpan.png";